import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useService } from "../../../../hooks";
import { brandInfo, searchRegex } from "../../../../constant";
import { AppContext, NavigatorContext } from "../../../../context";

export const useHeader = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const appContext = useContext(AppContext);
  const logo = appContext?.selectors?.getLogo() || brandInfo.logo;
  const logoWhite = appContext?.selectors?.getLogoWhite() || brandInfo.logoWhite;
  const {
    getLoggedInUserData,
    isUserLoggedIn,
    logout: logoutUser,
  } = useService("User");
  const {
    getActiveCar,
    isDesktop,
    isModuleEnabled,
    // getThemeMode,
    // setThemeMode,
    toggleCartBox,
    toggleBodyClass,
  } = useService("Misc");
  const { getLocationData, navigateTo: moveTo } = useService("Router");
  const { getCartData: fetchCartData } = useService("Order");
  const { getProduct } = useService("Product");
  const { getService } = useService("Service");
  const user = getLoggedInUserData();
  const currentUrl = getLocationData().href;
  const [temporaryUser, settemporaryUser] = useState<boolean>(false);
  const [showUserNav, setshowUserNav] = useState<boolean>(false);
  const [searchList, setsearchList] = useState([]);
  const [filteredList, setfilteredList] = useState([]);
  const userProfileImage = "";
  const [searchKey, setsearchKey] = useState<string>("");
  const [activeCar, setactiveCar] = useState(getActiveCar());
  const [cityDetail, setcityDetail] = useState<boolean>(false);
  const [showSideCart, setshowSideCart] = useState<boolean>(false);
  const [showNavBar, setshowNavBar] = useState<boolean>(false);
  const [showSearchResult, setshowSearchResult] = useState<boolean>(false);
  const [cartCount, setcartCount] = useState<number>(0);
  const [activeTopBar, setactiveTopBar] = useState(isDesktop());
  const showCarSelector = useMemo(
    () => () => {
      return (
        isModuleEnabled(["Car"]) &&
        !currentUrl.includes("car/edit") &&
        !currentUrl.includes("car/add") &&
        (!isUserLoggedIn() ||
          !["manager", "company", "branch", "representative"].includes(
            user?.role
          ))
      );
    },
    [currentUrl, isModuleEnabled, isUserLoggedIn, user?.role]
  );

  const getServicesData = useCallback(
    async (productsData) => {
      const result = await getService({ status: "publish" });
      if (result.status) {
        const services = [];
        result.data.forEach((e) => {
          e.type = "service";
          services.push(e);
        });
        setsearchList([...productsData, ...services]);
      }
    },
    [getService, setsearchList]
  );

  const getProductsData = useCallback(async () => {
    const result = await getProduct({ status: "publish" });
    if (result.status) {
      const products = [];
      result.data.forEach((e) => {
        e.type = "product";
        products.push(e);
      });
      getServicesData(products);
    }
  }, [getProduct, getServicesData]);

  // const toggleThemeMode = useCallback(() => {
  //     console.log('toggleThemeMode')
  //     if (getThemeMode() === "theme-light") {
  //         setThemeMode("theme-dark")
  //     } else setThemeMode("theme-light")
  // }, [getThemeMode, setThemeMode])

  const getCartData = useCallback(() => {
    let cartData = fetchCartData(),
      cartCount = 0;
    cartData.forEach((e) => {
      cartCount += e.purchaseQuantity;
    });
    setcartCount(cartCount);
  }, [fetchCartData]);

  const loadHeader = useCallback(() => {
    // toggleThemeMode()
    if (localStorage.getItem("tempLogin") === "true") {
      settemporaryUser(true);
    }
    getCartData();
    getProductsData();
    if (isDesktop() && isModuleEnabled(["TopNavbarBanner"])) {
      if (localStorage.getItem("topBarBanner") !== "no")
        toggleBodyClass("pt80");
      else toggleBodyClass("pt80", "pt0");
    }
  }, [
    getCartData,
    getProductsData,
    isDesktop,
    isModuleEnabled,
    toggleBodyClass,
  ]);

  useEffect(() => {
    loadHeader();
  }, [loadHeader]);

  const toggleTopNavBar = useCallback(() => {
    console.log("toggleTopNavBar");
    setactiveTopBar(false);
    localStorage.setItem("topBarBanner", "no");
    toggleBodyClass("pt80", "pt0");
  }, [toggleBodyClass]);

  const sendBackToAdmin = useCallback(() => {
    console.log("sendBackToAdmin");
    localStorage.removeItem("tempUserData");
    localStorage.removeItem("tempLogin");
    moveTo({ route: "/admin/dashboard" });
  }, [moveTo]);

  const toggleUserNav = useCallback(() => {
    console.log("toggleUserNav");
    setshowUserNav(!showUserNav);
  }, [showUserNav]);

  const logout = useCallback(() => {
    console.log("logout");
    setshowUserNav(false);
    logoutUser("/");
  }, [logoutUser]);

  const searchProduct = useCallback(
    (e) => {
      console.log("searchProduct");
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        let tempSearchKey = e.target.value.toLowerCase();
        setsearchKey(e.target.value);
        let tempTitle = "",
          tempSku = "",
          newFilteredList = [];
        searchList.forEach((e) => {
          tempTitle = e.title ? e.title.toLowerCase() : "";
          tempSku = e.sku ? e.sku.toLowerCase() : "";
          if (
            (tempSku !== "" && tempSku.search(tempSearchKey) !== -1) ||
            (tempTitle !== "" && tempTitle.search(tempSearchKey) !== -1)
          )
            newFilteredList.push(e);
        });
        setfilteredList(newFilteredList);
        if (tempSearchKey === "")
          document.getElementsByTagName("body")[0].className = "";
        else
          document.getElementsByTagName("body")[0].className =
            "searchbar-open search-result-open";
      }
    },
    [searchList]
  );

  const productSearch = useCallback(() => {
    console.log("productSearch");
  }, []);

  const resetProductSearch = useCallback(() => {
    console.log("resetProductSearch");
    setfilteredList([]);
    setsearchKey("");
  }, [setfilteredList, setsearchKey]);

  const toggleCart = useCallback(() => {
    console.log("toggleCart");
    setshowSideCart(!showSideCart);
    toggleCartBox();
  }, [showSideCart, toggleCartBox]);

  const cityDescription = useCallback(() => {
    console.log("cityDescription");
    setcityDetail(!cityDetail);
    toggleBodyClass("locationbar-open");
  }, [cityDetail, toggleBodyClass]);

  const navBackGround = useCallback(() => {
    console.log("navBackGround");
    setshowNavBar(!showNavBar);
    toggleBodyClass("nav-open");
  }, [showNavBar, toggleBodyClass]);

  const searchResultBackGround = useCallback(() => {
    console.log("searchResultBackGround");
    setshowSearchResult(false);
    setsearchKey("");
    document.getElementsByTagName("body")[0].className = "";
  }, [setsearchKey]);

  const navigateToLink = useCallback(
    (link) => {
      console.log("navigateToLink");
      navigateTo({ route: link });
      if (!isDesktop()) toggleBodyClass("nav-open");
    },
    [isDesktop, navigateTo, toggleBodyClass]
  );

  return {
    showCarSelector,
    getSelectedCar: setactiveCar,
    toggleTopNavBar,
    activeTopBar,
    cityDetail,
    cityDescription,
    cartCount,
    toggleUserNav,
    userProfileImage,
    showUserNav,
    sendBackToAdmin,
    logout,
    productSearch,
    resetProductSearch,
    searchResultBackGround,
    user,
    showSideCart,
    navBackGround,
    toggleCart,
    searchKey,
    searchProduct,
    filteredList,
    settemporaryUser,
    temporaryUser,
    activeCar,
    currentUrl,
    navigateToLink,
    showSearchResult,
    logo,
    logoWhite,
  };
};
